import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  type Batch,
  type ReceiveBatchParams,
} from "../../../domain/entities/batch";
import { type BatchesDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const receiveBatch = createAsyncThunk<
  Batch,
  ReceiveBatchParams,
  { dispatch: BatchesDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.RECEIVE_BATCH, async (params, { extra }) => {
  return await extra.batchesRepo.receiveBatch(params);
});
